import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "sign-in-page" }
const _hoisted_2 = {
  class: "welcome-panel",
  "aria-label": "Welcome to LotTrackr"
}
const _hoisted_3 = { class: "welcome-copy" }
const _hoisted_4 = { class: "sign-in-panel" }
const _hoisted_5 = { class: "form-container" }
const _hoisted_6 = {
  class: "sign-in-card",
  "aria-labelledby": "sign-in-title"
}
const _hoisted_7 = { id: "sign-in-title" }
const _hoisted_8 = {
  key: 0,
  class: "description"
}
const _hoisted_9 = ["aria-busy"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "input-wrapper" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "field"
}
const _hoisted_14 = { class: "input-wrapper" }
const _hoisted_15 = ["type", "disabled"]
const _hoisted_16 = ["aria-label", "aria-pressed"]
const _hoisted_17 = { class: "forgot-password" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "form-error",
  role: "alert"
}
const _hoisted_20 = {
  key: 2,
  class: "form-success",
  role: "status"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "sign-in-footer" }

import { ref } from "vue";
  import { useRouter } from "vue-router";
  import { Mail, LockKeyhole, Eye, EyeOff } from "lucide-vue-next";
  import store from "@/store";
  import { UserRoles } from "@/enums/UserRoles";
  import LocalStorageService from "@/services/localStorage.service";

  const logoUrl =
    "https://public-lottrack-prod-bucket.s3.ap-southeast-2.amazonaws.com/default/logos/logo-color.webp";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

  const router = useRouter();
  const year = new Date().getFullYear();
  const email = ref("");
  const password = ref("");
  const showPassword = ref(false);
  const recovering = ref(false);
  const pending = ref(false);
  const error = ref("");
  const resetSent = ref(false);

  function setRecovery(value: boolean) {
    recovering.value = value;
    password.value = "";
    showPassword.value = false;
    error.value = "";
    resetSent.value = false;
  }

  async function submit() {
    if (pending.value) return;

    pending.value = true;
    error.value = "";
    resetSent.value = false;
    const normalizedEmail = email.value.trim().toLowerCase();

    try {
      if (recovering.value) {
        await store.dispatch("user/forgotPassword", normalizedEmail);
        resetSent.value = true;
      } else {
        const response = await store.dispatch("user/login", {
          email: normalizedEmail,
          password: password.value,
        });

        password.value = "";
        const user = response.data.user;
        const destination = store.state.user.redirectLink;

        if (destination) {
          await router.push(destination);
        } else if (user.role === UserRoles.CUSTOMER) {
          await router.push("/customer");
        } else if (user.role === UserRoles.SUPER_ADMIN) {
          await router.push({ name: "AdminUsers" });
        } else if (
          user.role === UserRoles.SALES_PERSON &&
          !user.detailsId?.estateIds?.length
        ) {
          await router.push({ name: "LandownerProfile" });
        } else {
          await router.push("/dashboard");
        }
      }
    } catch (failure) {
      const response = (
        failure as {
          response?: { data?: { statusCode?: number; message?: string } };
        }
      ).response;

      if (!recovering.value && response?.data?.statusCode === 403) {
        const destination = store.state.user.redirectLink;

        LocalStorageService.set(
          "urlAfterVerify",
          destination ? router.resolve(destination).fullPath : "/dashboard"
        );
        await router.push({
          name: "RegistrationVerifyView",
          params: { userEmail: normalizedEmail },
        });
      } else {
        error.value =
          response?.data?.message || "Something went wrong. Please try again.";
      }
    } finally {
      pending.value = false;
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          "aria-label": "LotTrackr home"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: logoUrl,
              alt: "LotTrackr",
              class: "brand-logo"
            })
          ]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Welcome back", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, "Let's pick up where you left off.", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        class: "mobile-logo",
        to: "/",
        "aria-label": "LotTrackr home"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: logoUrl,
            alt: "LotTrackr"
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(recovering.value ? "Reset your password" : "Sign in"), 1),
          (recovering.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Enter your email address and we'll send you a password reset link. "))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            "aria-busy": pending.value,
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "signin-email" }, "Email address", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(Mail), {
                  size: 20,
                  "aria-hidden": "true"
                }),
                _withDirectives(_createElementVNode("input", {
                  id: "signin-email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  type: "email",
                  autocomplete: "email",
                  placeholder: "Enter your email address",
                  required: "",
                  disabled: pending.value
                }, null, 8, _hoisted_12), [
                  [_vModelText, email.value]
                ])
              ])
            ]),
            (!recovering.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { for: "signin-password" }, "Password", -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(LockKeyhole), {
                      size: 20,
                      "aria-hidden": "true"
                    }),
                    _withDirectives(_createElementVNode("input", {
                      id: "signin-password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                      type: showPassword.value ? 'text' : 'password',
                      autocomplete: "current-password",
                      placeholder: "Enter your password",
                      required: "",
                      disabled: pending.value
                    }, null, 8, _hoisted_15), [
                      [_vModelDynamic, password.value]
                    ]),
                    _createElementVNode("button", {
                      class: "password-toggle",
                      type: "button",
                      "aria-label": showPassword.value ? 'Hide password' : 'Show password',
                      "aria-pressed": showPassword.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
                    }, [
                      (showPassword.value)
                        ? (_openBlock(), _createBlock(_unref(Eye), {
                            key: 0,
                            size: 20,
                            "aria-hidden": "true"
                          }))
                        : (_openBlock(), _createBlock(_unref(EyeOff), {
                            key: 1,
                            size: 20,
                            "aria-hidden": "true"
                          }))
                    ], 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "text-button",
                      type: "button",
                      disabled: pending.value,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (setRecovery(true)))
                    }, " Forgot password? ", 8, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true),
            (resetSent.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, " If an account exists for this email address, you'll receive a password reset link. Check your inbox and spam folder. "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "submit-button",
              type: "submit",
              disabled: pending.value
            }, _toDisplayString(pending.value
                  ? recovering.value
                    ? "Sending…"
                    : "Signing in…"
                  : recovering.value
                  ? "Send reset password link"
                  : "Sign in"), 9, _hoisted_21),
            (recovering.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "text-button back-button",
                  type: "button",
                  disabled: pending.value,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (setRecovery(false)))
                }, " Back to sign in ", 8, _hoisted_22))
              : _createCommentVNode("", true)
          ], 40, _hoisted_9)
        ])
      ]),
      _createElementVNode("footer", _hoisted_23, [
        _createElementVNode("span", null, "© " + _toDisplayString(_unref(year)) + " LotTrackr. All rights reserved.", 1),
        _createVNode(_component_router_link, { to: { name: 'PrivacyPolicy' } }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Privacy Policy ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'Terms' } }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Terms of Service ", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})